import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderDetailInfoTable from './OrderDetail/OrderDetailInfoTable'
import { GetOrderPaletInfoForOrderInfoTable } from '../../Helpers/OrderInfoHelper'
import { useTranslation } from 'react-i18next';
import BOLImagesComponent from './BOLImagesComponent';
import { truncate } from '../../Helpers/generalHelper';

export default function OrderPaletInfo(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <div className={classes.orderInfo}>
        <div className={classes.header}>
            <div className={classes.leftHeader}>
                <div className={classes.orderno}>
                    {t("Client")}
                </div>
                <div className={classes.orderNumber} title = {props.productionOrder.customerName}>
                    {props.productionOrder.customerName.length > 18 ? truncate(props.productionOrder.customerName, 18) + "..." : props.productionOrder.customerName}
                </div>
            </div>
            <div className={classes.middleHeader}>
                <BOLImagesComponent bolMetaData={JSON.parse(props.productionOrder.bolMetaData).find(x => x.MetaDataType === 1).MetaData}></BOLImagesComponent>
            </div>
            <div className={classes.rightHeader}>
                <div className={classes.orderno}>
                    {t("Line")}
                </div>
                <div className={classes.orderNumber}>
                    {props.productionOrder.machinePlannedCode}
                </div>
            </div>
        </div>
        <OrderDetailInfoTable rows={GetOrderPaletInfoForOrderInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        height: "150px",
        float: "left",
        paddingLeft: "30px",
        width: "44%",
        boxSizing: "border-box"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: "block",
        marginBottom: "10px"
    },
    orderTable: {
        display: "block"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    rightHeader: {
        textAlign: "right",
        width: "10%",
        float: "left"
    },
    middleHeader: {
        width: "40%",
        float: "left",
        height: "67px",
        paddingTop: "15px",
        boxSizing: "border-box",
        paddingRight: "80px"
    },
    leftHeader: {
        width: "50%",
        float: "left"
    }
});